package com.zaurh.portfolio.data

import kotlinx.serialization.Serializable

@Serializable
data class ContactDTO(
    val success: Boolean,
    val data: ContactData,
    val message: String
)

@Serializable
data class ContactData(
    val name: String,
    val email: String,
    val subject: String,
    val message: String
)